// Textos de ajuda dos dois saldos. Os modais de ajuda e as dicas do "i" do painel da Home
// (AJ2-02) leem daqui, para o conteúdo aprovado não ficar em dois lugares.
export const AJUDA_DOS_PONTOS_JOGA_JUNTO =
  'Este é o saldo total de pontos acumulados como resultado do reconhecimento de seus colegas e das ações de engajamento.';

export const AJUDA_DOS_PONTOS_REALIZACOES = 'Este é o saldo total de pontos acumulados na Dinâmica Realização Destaque.';
